export default {"src":"/_next/static/media/mongoDB.d8d2b67f.svg","height":249,"width":112,"blurWidth":0,"blurHeight":0};